export const RECHARGE_REPORT_PERIOD_PRESETS = [7, 30, 60, 90];
export const RECHARGE_REPORT_TYPE_BENEFICIARIES = 'beneficiaries';
export const RECHARGE_REPORT_TYPE_ORDERS = 'orders';
const SEARCH_MIN_LENGTH = 3;
function onlyDigits(value) {
    return value.replace(/\D/g, '');
}
export function buildBeneficiaryFullName(beneficiary) {
    return `${beneficiary.firstName ?? ''} ${beneficiary.lastName ?? ''}`.trim();
}
export function matchesBeneficiarySearch(beneficiary, term) {
    const trimmed = term.trim();
    if (trimmed.length < SEARCH_MIN_LENGTH) {
        return true;
    }
    const digits = onlyDigits(trimmed);
    if (digits.length >= SEARCH_MIN_LENGTH && onlyDigits(beneficiary.document ?? '').includes(digits)) {
        return true;
    }
    return buildBeneficiaryFullName(beneficiary).toLocaleLowerCase('pt-BR').includes(trimmed.toLocaleLowerCase('pt-BR'));
}
